import { LoginForm } from '../../component/account/login-form'
import { browserUtil, tokenService } from '@grndhouse/react-common'
import React from 'react'

export const LoginScreen = (): React.ReactElement => {
  if (tokenService.hasAccessToken()) {
    browserUtil.redirect('/auth/')
    return <></>
  } else
    return (
      <div className="floating-form">
        <LoginForm />
      </div>
    )
}
